import { render, staticRenderFns } from "./whatsAppButton.vue?vue&type=template&id=0537f5e0&scoped=true&"
import script from "./whatsAppButton.vue?vue&type=script&lang=js&"
export * from "./whatsAppButton.vue?vue&type=script&lang=js&"
import style0 from "./whatsAppButton.vue?vue&type=style&index=0&id=0537f5e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0537f5e0",
  null
  
)

export default component.exports